import { render, staticRenderFns } from "./JuniorTotalPoint.vue?vue&type=template&id=34bebb5c"
import script from "./JuniorTotalPoint.vue?vue&type=script&lang=ts"
export * from "./JuniorTotalPoint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports